<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="isInvite ? $t('companies.users.invite_title') : $t('companies.users.edit_title')"
  :rightActions="rightActions"
)
  UiFormGroup(
    v-if="isInvite"
    :label="$t('admin_users.company')"
    :vuelidateModel="v$.form.company_id"
  )
    UiMultiselect(
      :options="companies"
      v-model="form.company_id"
      valueProp="id"
      label="name"
      placeholder="Select a company"
      :error="v$.form.company_id.$error"
    )

  UiFormGroup(
    v-else
    :label="$t('admin_users.company')"
  )
    UiInput(
      v-model="company_name"
      :disabled="true"
    )

  UiFormGroup(
    :label="$t('companies.users.name')"
    label-for="name-input"
    label-cols="4"
    :vuelidateModel="v$.form.name"
  )
    UiInput#name-input(
      v-model="form.name"
      :error="v$.form.name.$error"
    )

  UiFormGroup(
    :label="$t('companies.users.email')"
    :vuelidateModel="v$.form.email"
  )
    UiInput#email-input(
      v-model="form.email"
      type="email"
      :error="v$.form.email.$error"
    )

  UiFormGroup(
    :label="$t('companies.users.role')"
    :vuelidateModel="v$.form.role"
  )
    UiMultiselect(
      v-model="form.role"
      :options="rolesOptions"
      :canDeselect="false"
      :canClear="false"
      :error="v$.form.role.$error"
    )
</template>

<script>
import ApiCompanyUsers from "@/api/companyUsers.js";
import ApiAdminCompanyUsers from "@/api/admin_company_users.js";
import useVuelidate from "@vuelidate/core";
import { email, required, requiredIf } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        company_id: {
          required: requiredIf(this.isInvite),
        },
        name: {
          required,
        },
        email: {
          required,
          email,
        },
        role: {
          required,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      isInvite: false,
      form: {
        company_id: null,
        name: "",
        email: "",
        role: null,
      },
      companies: [],
      rolesOptions: [
        { label: "Admin", value: "admin" },
        { label: "Reader", value: "reader" },
      ],
      company_name: "",
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(User) {
      this.v$.$reset();
      this.loadCompanies();
      if (User) {
        this.isInvite = false;
        this.form = {
          id: User.id,
          name: User.user_name,
          email: User.email,
          role: User.role,
          company_id: User.company_id,
        };
        this.company_name = User.company_name;
      } else {
        this.isInvite = true;
        this.form = {
          name: "",
          email: "",
          role: null,
          company_id: null,
        };
      }
      this.show = true;
    },

    close() {
      this.show = false;
    },

    loadCompanies() {
      ApiAdminCompanyUsers.getCompanies().then((resp) => {
        this.companies = resp.data;
      });
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        const params = {
          name: form.name,
          email: form.email,
          role: form.role,
        };
        if (this.isInvite) {
          ApiCompanyUsers.inviteUser(form.company_id, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        } else {
          ApiCompanyUsers.updateUser(form.company_id, form.id, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        }
      });
    },
  },
};
</script>
